import React, { useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { DatePicker } from 'react-materialize';
import { Redirect } from 'react-router-dom';
import './WinnerContest.css';
import WinnerItem from './WinnerItem';
import { CSVLink } from 'react-csv';
import { dateToMMDDYYYY, startDayOfDate, endDayOfDate } from '../../utils/DateUtil';

function WinnersContest(props) {
  const [date, setDate] = useState(null);
  const [contests, setContests] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [winners, setWinners] = useState([]);
  const [validDate, setValidDate] = useState(true);
  const { firestore, auth } = props;

  if (!auth.uid) return <Redirect to="/signin" />;

  const getContestName = (contestId) => {
    let contestName = '';
    contests.forEach((c) => {
      if (c.id === contestId) {
        contestName = c.name;
      }
    });
    return contestName;
  };

  const generateData = () => {
    const data = [];
    winners.forEach((w) => {
      profiles.forEach((p) => {
        if (w.userId === p.id) {
          data.push({
            userId: p.id,
            name: p.name,
            lastName: p.lastName,
            userName: p.userName,
            email: p.email,
            country: p.countryCode,
            state: p.stateCode,
            contestName: getContestName(w.contestId),
            contestId: w.contestId,
          });
        }
      });
    });

    console.log('data', data);
    return data;
  };

  const filterProfiles = (winners) => {
    const profilesIds = [];
    winners.forEach((w) => {
      if (!profilesIds.includes(w.userId)) {
        profilesIds.push(w.userId);
      }
    });
    return profilesIds;
  };

  const filterContest = (winners) => {
    const contestIds = [];
    winners.forEach((w) => {
      if (!contestIds.includes(w.contestId)) {
        contestIds.push(w.contestId);
      }
    });
    return contestIds;
  };

  const getWinnerContestByDate = () => {
    if (date != null) {
      let winnerContestResult = [];
      let profileResults = [];
      let contestResults = [];
      setValidDate(true);
      const startDay = startDayOfDate(date);
      const endDay = endDayOfDate(date);

      firestore
        .collection('winnerContest')
        .where('createdAt', '>=', startDay)
        .where('createdAt', '<=', endDay)
        .get()
        .then((querySnapshot) => {
          const winnerContest = [];
          querySnapshot.forEach((doc) => {
            winnerContest.push(doc.data());
          });
          winnerContestResult = winnerContest;

          const profilePromises = [];
          filterProfiles(winnerContest).forEach((w) => {
            const ref = firestore.collection('profiles').doc(w);
            profilePromises.push(ref.get());
          });

          return Promise.all(profilePromises);
        })
        .then((profiles) => {
          profiles.forEach((p) => {
            profileResults.push(p.data());
          });

          const contestsPromises = [];
          filterContest(winnerContestResult).forEach((w) => {
            const ref = firestore.collection('contests').doc(w);
            contestsPromises.push(ref.get());
          });

          return Promise.all(contestsPromises);
        })
        .then((contests) => {
          contests.forEach((c) => {
            contestResults.push(c.data());
          });

          setContests(contestResults);
          setProfiles(profileResults);
          setWinners(winnerContestResult);
        })
        .catch((e) => {
          console.log('error get winnerContest', e.message);
        });
    } else {
      setValidDate(false);
    }
  };

  return (
    <div className="container">
      <div className="title-section">Winner of the contest</div>
      <div className="row">
        <div className="col">
          <p>Date: {date != null ? dateToMMDDYYYY(date) : null}</p>
          <DatePicker
            onChange={(value) => {
              const date = new Date(value);
              setDate(date.toString());
            }}
          />
        </div>
        <div className="col">
          <button className="waves-effect waves-light btn btn-large" onClick={getWinnerContestByDate}>
            Search
          </button>
        </div>
        {winners.length > 0 ? (
          <CSVLink data={generateData()} filename={'Winners.csv'}>
            Export data
          </CSVLink>
        ) : (
          <div />
        )}
      </div>
      {!validDate ? <h5 className="red-text">Select Date</h5> : <div />}
      <div className="winnersContainer">
        {winners.map((w) => {
          const profile = profiles.filter((p) => p.id === w.userId);
          const contest = contests.filter((c) => c.id === w.contestId);
          return <WinnerItem key={w.id} winner={w} profile={profile[0]} contest={contest[0]} />;
        })}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

export default compose(firestoreConnect([]), connect(mapStateToProps))(WinnersContest);
